import { join } from 'lodash';

const getBrandText = (brands) => join(brands, ', ');

export default getBrandText;
